<script>
    import TopThreeSelectField from "./TopThreeSelectField.svelte";
    import { getLocalStorageItem, setLocalStorageItem, post } from '../../utility.js';
    import { onMount } from "svelte";

    export let subcategoryID;
    export let questions;
    export let selected;

    // is accessed dynamically from SubcategoryView
    export function triggerSubmission(validate) {
        console.log("checking child component: " + validate);
        return subTrigger(validate);
    }

    let multipleChoiceTopThree = [];
    let topThreeMessage = "";
    let questionID;


    onMount(async () => {
        questionID = questions[0].question_id;
        loadSavedAnswers();
        if (selected.length < 3) {
            // submit so that this subcategory is skipped if the user has less equal 3 selected
            topThreeMessage = `Bitte wähle auf den vorherigen Seiten mindestens 3 Dinge aus!`;
        }
    });

    function loadSavedAnswers() {
        const questionnaireAnswers = getLocalStorageItem('questionnaireAnswers') || {};
        const answerString = questionnaireAnswers[subcategoryID]?.[questionID];
        if (answerString) {
            try {
                let mctop3 = JSON.parse(answerString);
                multipleChoiceTopThree = [];
                console.log(mctop3);
                for (const mctop3element of mctop3) {
                    if (selected.includes(mctop3element)) {
                        multipleChoiceTopThree.push(mctop3element)
                    }
                }
            } catch (error) {
                console.error('Error parsing JSON:', error);
            }
        }
    }

    function subTrigger(validate) {
        if (!validate && !selected) return true;
        if (validate && selected.length < 3) return false;
        if (validate && selected.length >= 3 && multipleChoiceTopThree.length !== 3) {
            topThreeMessage = `Bitte wähle genau drei Favoriten aus!`;
            return false;
        }

        try {
            post('submit-answers/', {answers: {[questionID]: JSON.stringify(multipleChoiceTopThree)}});
        } catch (error) {
            console.error('Error submitting data:', error);
            return false;
        }

        const questionnaireAnswers = getLocalStorageItem('questionnaireAnswers') || {};
        questionnaireAnswers[subcategoryID] = {[questionID]: JSON.stringify(multipleChoiceTopThree)};
        setLocalStorageItem('questionnaireAnswers', questionnaireAnswers);
        if (selected.length > 3) {
            topThreeMessage = 'Deine Antworten wurden gespeichert.';
        }

        return true;
    }
</script>

{#if selected}
    {#if selected.length >= 3}
        Was sind deine drei Favoriten in Bezug auf deine beruflichen Vorstellungen?
        <TopThreeSelectField bind:selectedOptions={multipleChoiceTopThree}
            id="topThree"
            label="Deine drei Favoriten"
            options={selected}>
        </TopThreeSelectField>
        {#if multipleChoiceTopThree.length > 0}
            Von dir ausgewählt:
            <ul>
                {#each multipleChoiceTopThree as e}
                    <li>{e}</li>
                {/each}
            </ul>
        {/if}
    {/if}
{/if}

{#if topThreeMessage}
    <div>{topThreeMessage}</div>
{/if}